import { addHours, addMinutes, format, setMilliseconds, setMinutes, setSeconds } from "date-fns";

/**
 * Returns a time string ("HH:mm") based on a base date (default: now),
 * plus an offset in minutes (default: 30), rounded UP to the next 5-minute mark.
 */
export const getTimePlusMinutesRoundedToNext5 = (baseDate: Date = new Date(), offsetMinutes = 30): string => {
  const datePlusOffset = addMinutes(baseDate, offsetMinutes);
  const minutes = datePlusOffset.getMinutes();

  const roundedMinutes = Math.ceil(minutes / 5) * 5;

  const normalized = setMilliseconds(setSeconds(datePlusOffset, 0), 0);

  if (roundedMinutes === 60) {
    const withHourOverflow = addHours(normalized, 1);
    return format(setMinutes(withHourOverflow, 0), "HH:mm");
  }

  return format(setMinutes(normalized, roundedMinutes), "HH:mm");
};
